import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
import { TalentFilterProvider } from '../../components/talent/TalentFilterContext';
//
import Main from './Main';
import NavHorizontal from './nav/NavHorizontal';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import Header from './header';
import MEITDAIChatBox from '../../pages/dashboard/MEITDAIChatBox';

// ----------------------------------------------------------------------

function DashboardLayoutInner() {
  const { themeLayout } = useSettingsContext();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />
        {isDesktop ? <NavHorizontal /> : renderNavVertical}
        <Main>
          <Outlet />
        </Main>
        <MEITDAIChatBox />
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />
        <Box
          sx={{
            display: { lg: 'flex' },
            zIndex: 1,
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}
          <Main>
            <Outlet />
          </Main>
        </Box>
        {/* <MEITDAIChatBox /> */}
      </>
    );
  }

  return (
    <>
      {!isDesktop && <Header onOpenNav={handleOpen} />}
      <Box
        sx={{
          display: { lg: 'flex' },
          zIndex: 1,
        }}
      >
        {renderNavVertical}
        <Main>
          <Outlet />
        </Main>
      </Box>
      {/* <MEITDAIChatBox /> */}
    </>
  );
}

// global talent filters (sector + year) persist across the talent pages
export default function DashboardLayout() {
  return (
    <TalentFilterProvider>
      <DashboardLayoutInner />
    </TalentFilterProvider>
  );
}
